/**
 * Components for LandingPage
 */

import React from 'react';
import { CheckCircle } from 'lucide-react';

interface FeatureCardProps {
  number: string;
  title: string;
  description: string;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({ number, title, description }) => (
  <div className="bg-white p-8 rounded-2xl shadow-sm">
    <div className="w-12 h-12 bg-[#4A6651]/10 rounded-xl flex items-center justify-center mb-4">
      <span className="text-2xl font-bold text-[#4A6651]">{number}</span>
    </div>
    <h3 className="text-xl font-semibold mb-3 text-gray-900" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
      {title}
    </h3>
    <p className="text-gray-600">{description}</p>
  </div>
);

interface BenefitCardProps {
  title: string;
  description: string;
}

export const BenefitCard: React.FC<BenefitCardProps> = ({ title, description }) => (
  <div className="flex items-start space-x-4 bg-white p-6 rounded-xl border border-gray-100">
    <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
    <div>
      <h3 className="text-xl font-semibold mb-2 text-gray-900" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
        {title}
      </h3>
      <p className="text-gray-600">{description}</p>
    </div>
  </div>
);

interface TestimonialCardProps {
  text: string;
}

export const TestimonialCard: React.FC<TestimonialCardProps> = ({ text }) => (
  <div className="bg-white p-6 rounded-xl shadow-sm">
    <p className="text-gray-600 italic mb-4">
      &quot;{text}&quot;
    </p>
    <div className="flex items-center">
      <div className="flex text-yellow-400">
        {'★★★★★'.split('').map((star, i) => (
          <span key={i}>{star}</span>
        ))}
      </div>
    </div>
  </div>
);